<template>
  <div>
    <div class="box">
      <div class="box-header with-border">
        <!--<div class="col-xs-12 text-right pull-right">-->
        <!--<div class="form-group input-group time-box pull-right">-->
        <!--<date-time-picker :date="menuTime.start" :option="dateoption" :limit="startLimit"></date-time-picker>-->
        <!--<date-time-picker :date="menuTime.end" :option="dateoption" :limit="endLimit"></date-time-picker>-->
        <!--<span class="input-group-btn">-->
        <!--<button class="btn btn-default submit-btn btn-search" type="button"-->
        <!--id="search" style="height: 72px" @click="getShopperStatus()">-->
        <!--<i class="fa fa-search"></i>-->
        <!--</button>-->
        <!--</span>-->
        <!--</div>-->
        <!--</div>-->
        <div class="col-xs-12 col-md-6">
          <h3 class="box-title">當日使用者註冊狀態</h3><br><br>
          <div class="box-body p-0">
            <div class="col-xs-12">
              <canvas id="today-shopper"></canvas>
            </div>
            <!--<hr class="visible-xs-block">-->
            <!--<div class="col-sm-6 col-xs-12">-->
            <!--<p class="text-center">-->
            <!--<strong>Language Overview</strong>-->
            <!--</p>-->
            <!--<canvas id="languagePie"></canvas>-->
            <!--</div>-->
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <h3 class="box-title">累積使用者註冊狀態</h3><br><br>
          <div class="box-body p-0">
            <div class="col-xs-12">
              <canvas id="total-shopper"></canvas>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <h3 class="box-title">當日不重複之使用者行為</h3><br><br>
          <div class="box-body p-0">
            <div class="col-xs-12">
              <canvas id="shopper-active"></canvas>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <h3 class="box-title">今日24小時訂單數與金額</h3><br><br>
          <div class="box-body p-0">
            <div class="col-xs-12">
              <canvas id="hour-brief"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
    <order-line-charts />
    <div class="box">
      <div class="box-header with-border">
        <div class="col-xs-12">
          <h3 class="box-title">一日所有店家狀態列表<span class="text-red text-12">(最多可選擇10間店家)</span></h3><br><br>
        </div>
        <div class="col-xs-12 col-md-6">
          <div class="col-xs-12 p-sm-10-p m-x-10 form-left">
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  品牌
                </span>
                <multiselect v-model="content.bindingBrandList"
                             placeholder="選擇品牌" label="label" track-by="value" :options="brandBrief"
                             :multiple="true" :allow-empty="true" :close-on-select="false"></multiselect>
                <!--<v-select v-model="content.bindingBrandList" :options="brandBrief" :multiple="true" class="h-38"></v-select>-->
                <!--<span class="input-group-addon c-pointer" style="border-radius: 0px 3px 3px 0px;" @click="getStoresTransactions()">-->
                <!--<i class="fa fa-search"></i>-->
                <!--</span>-->
              </div>
              <br />
            </div>
          </div>
          <div class="col-xs-12 p-sm-10-p m-x-10 form-left">
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  店家
                </span>
                <multiselect v-model="content.bindingStoreList"
                             placeholder="選擇店家" label="label" track-by="value" :options="storeBrief"
                             :multiple="true" :allow-empty="true":close-on-select="false"></multiselect>
                <!--<v-select v-model="content.bindingStoreList" :options="storeBrief" :multiple="true" class="h-38"></v-select>-->
                <!--<span class="input-group-addon c-pointer" style="border-radius: 0px 3px 3px 0px;" @click="getStoresTransactions()">-->
                  <!--<i class="fa fa-search"></i>-->
                <!--</span>-->
              </div>
              <br />
            </div>
          </div>

        </div>
        <div class="col-xs-12 col-md-6 text-right pull-right">
          <div class="form-group input-group time-box no-btn pull-right">
            <date-time-picker :date="menuTime.storeTime" :option="dateoption" :limit="storeLimit"></date-time-picker>
            <!--<input type="text" class="form-control time-picker" id="start-box" placeholder="起始時間">-->
            <!--<input type="text" class="form-control time-picker" id="end-box" placeholder="結束時間">-->
            <!--<span class="input-group-btn">-->
              <!--<button class="btn btn-default btn-search c-auto" type="button"-->
                      <!--id="search3" style="height: 36px">-->
                <!--<i class="fa fa-search"></i>-->
              <!--</button>-->
            <!--</span>-->
          </div>
        </div>
        <div class="col-xs-12 table-responsive" style="min-height: 300px;">
          <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
            <thead>
            <tr role="row">
              <th>店名 (ID)</th>
              <th>已接受數量</th>
              <th>拒絕數量</th>
              <th>例外數量</th>
              <th>已完成數量</th>
              <th>一般單數量</th>
              <th>團購單數量</th>
            </tr>
            </thead>
            <tbody>
            <tr class="even" role="row" v-for="store in storeStatusList">
              <td>{{store.store_name}} ({{store.store_id}})</td>
              <td>{{store.order_count_accept}}</td>
              <td>{{store.order_count_reject}}</td>
              <td>{{store.order_count_accept - store.order_count_finish}}</td>
              <td>{{store.order_count_finish}}</td>
              <td>{{store.order_count_day_normal}}</td>
              <td>{{store.order_count_day_group}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import OrderLineCharts from '@/components/views/Chart/Temp/OrderLineCharts.vue'
import moment from 'moment'
var todayChart, totalChart, shopperActiveChart, hourBriefChart
export default {
  components: {
    'date-time-picker': datetimePicker,
    'order-line-charts': OrderLineCharts
  },
  data () {
    return {
      brandList: [],
      changeStore: false,
      storeStatusList: {},
      content: {
        bindingStoreList: [],
        bindingBrandList: []
      },
      oldUrl: '',
      storeBrief: [],
      brandBrief: [],
      // transactions
      transactionLabels: [],
      transactions: {
        order_count_accum: [],
        order_count_day: [],
        order_count_day_normal: [],
        order_count_day_group: [],
        money_accum: [],
        money_accum_mean: [],
        money_day: [],
        money_day_normal: [],
        money_day_group: [],
        money_day_mean: [],
        item_count_accum: [],
        item_count_accum_mean: [],
        item_count_day: [],
        item_count_day_normal: [],
        item_count_day_group: [],
        item_count_day_mean: []
      },
      // hour brief
      hourBriefLabels: [],
      hourBrief: {
        total_order: [],
        total_money: [],
        total_amount: []
      },
      // shopperStatus
      labels: [],
      shopperState: {
        today: {
          total: [],
          certify: [],
          fb: [],
          google: [],
          line: [],
          nidin: []
        },
        total: {
          total: [],
          certify: [],
          fb: [],
          google: [],
          line: [],
          nidin: []
        }
      },
      // shopperActive
      activeLabels: [],
      shopperActive: {
        cr: [],
        cancel: [],
        search: [],
        read: [],
        feedback: []
      },
      // date
      menuTime: {
        storeTime: {
          time: moment().add(-1, 'days').format('YYYY-MM-DD')
        },
        start: {
          time: ''
        },
        end: {
          time: moment().add(1, 'days').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      storeLimit: [
        {
          type: 'fromto',
          to: moment().format('YYYY-MM-DD')
        }
      ]
    }
  },
  methods: {
    checkLimit (val) {
      if (this.content.bindingStoreList.length > 10) {
        this.content.bindingStoreList.shift()
      }
      if (this.content.bindingStoreList.length) {
        this.getStoresTransactions()
      } else {
        this.storeStatusList = {}
      }
    },
    clickSearch () {
      if (this.content.bindingStoreList.length) this.getStoresTransactions()
    },
    getStoresTransactions () {
      const list = this.content.bindingStoreList
      const day = moment(this.menuTime.storeTime.time, 'YYYY-MM-DD').format('YYYYMMDD')
      var ids = ''
      for (var i = 0; i < list.length; i++) {
        ids = ids + list[i].value + ','
      }
      ids = ids.slice(0, -1)
      var self = this
      var data = {
        start_time: day,
        end_time: day,
        ids: ids
      }
      var url = ''
      url = '/statistic/storeTransactions?start_date=' + data.start_time + '&end_date=' + data.end_time + '&store_ids=' + data.ids
      if (this.oldUrl !== url) {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            let resDay = moment(day, 'YYYYMMDD').format('YYYY-MM-DD')
            if (response.data.statistics[resDay]) self.storeStatusList = response.data.statistics[resDay].store_info
            self.oldUrl = url
          }
        })
      }
    },
    getStoreBrief (brandId) {
      console.log('getStoreBrief | SystemDashboard')
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sortname ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
          }
        }
      })
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          var brandIds = ''
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
            brandIds = brandIds + bList[i].brand_id + ','
          }
          brandIds = brandIds.slice(0, -1)
          // console.log(self.brandBrief)
        }
      })
    },
    changeStoreBrief () {
      this.storeBrief = []
      // console.log(this.content.bindingBrandList)
      for (let i = 0; i < this.content.bindingBrandList.length; i++) {
        this.getStoreBrief(this.content.bindingBrandList[i].value)
      }
    },
    getTransactions (type, id) {
      this.transactionLabels = []
      this.transactions = {
        order_count_accum: [],
        order_count_day: [],
        order_count_day_normal: [],
        order_count_day_group: [],
        money_accum: [],
        money_accum_mean: [],
        money_day: [],
        money_day_normal: [],
        money_day_group: [],
        money_day_mean: [],
        item_count_accum: [],
        item_count_accum_mean: [],
        item_count_day: [],
        item_count_day_normal: [],
        item_count_day_group: [],
        item_count_day_mean: []
      }
      var self = this
      var data = {
        start_time: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      }
      var url = ''
      if (type === 'brand') url = '/statistic/brandTransactions?start_date=' + data.start_time + '&end_date=' + data.end_time + '&brand_ids=' + id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var tList = response.data.statistics
          var info
          for (var i in tList) {
            if (type === 'brand') {
              info = 'brand_info'
            } else if (type === 'store') {
              info = 'store_info'
            }
            self.transactionLabels.push(moment(i, 'YYYY-MM-DD').format('MM/DD'))
            self.transactions.order_count_accum.push(tList[i][info][id].order_count_accum)
            self.transactions.order_count_day.push(tList[i][info][id].order_count_day)
            self.transactions.order_count_day_normal.push(tList[i][info][id].order_count_day_normal)
            self.transactions.order_count_day_group.push(tList[i][info][id].order_count_day_group)
            self.transactions.money_accum.push(tList[i][info][id].money_accum)
            self.transactions.money_accum_mean.push(tList[i][info][id].money_accum_mean)
            self.transactions.money_day.push(tList[i][info][id].money_day)
            self.transactions.money_day_normal.push(tList[i][info][id].money_day_normal)
            self.transactions.money_day_group.push(tList[i][info][id].money_day_group)
            self.transactions.money_day_mean.push(tList[i][info][id].money_day_mean)
            self.transactions.item_count_accum.push(tList[i][info][id].item_count_accum)
            self.transactions.item_count_accum_mean.push(tList[i][info][id].item_count_accum_mean)
            self.transactions.item_count_day.push(tList[i][info][id].item_count_day)
            self.transactions.item_count_day_normal.push(tList[i][info][id].item_count_day_normal)
            self.transactions.item_count_day_group.push(tList[i][info][id].item_count_day_group)
          }
          self.showTransactionsChart(type)
        }
      })
    },
    getShopperStatus () {
      this.labels = []
      this.shopperState = {
        today: {
          total: [],
          certify: [],
          fb: [],
          google: [],
          line: [],
          nidin: []
        },
        total: {
          total: [],
          certify: [],
          fb: [],
          google: [],
          line: [],
          nidin: []
        }
      }
      var self = this
      var data = {
        start_time: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      }
      var url = '/statistic/shopperStatus?start_date=' + data.start_time + '&end_date=' + data.end_time
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.shopper_status_list
          for (var i in sList) {
            self.labels.push(moment(sList[i].date, 'YYYY-MM-DD').format('MM/DD'))
            self.shopperState.today.total.push(sList[i].total_day)
            self.shopperState.today.certify.push(sList[i].verified_day)
            self.shopperState.today.fb.push(sList[i].from_facebook_day)
            self.shopperState.today.google.push(sList[i].from_google_day)
            self.shopperState.total.total.push(sList[i].total_accum)
            self.shopperState.today.line.push(sList[i].from_line_day)
            self.shopperState.today.nidin.push(sList[i].from_phone_day)

            self.shopperState.total.certify.push(sList[i].verified_accum)
            self.shopperState.total.fb.push(sList[i].from_facebook_accum)
            self.shopperState.total.google.push(sList[i].from_google_accum)
            self.shopperState.total.line.push(sList[i].from_line_accum)
            self.shopperState.total.nidin.push(sList[i].from_phone_accum)
          }
          self.getShopperActivity()
          self.showShopperChart()
        }
      })
    },
    getShopperActivity () {
      this.activeLabels = []
      this.shopperActive = {
        cr: [],
        cancel: [],
        search: [],
        read: [],
        feedback: []
      }
      var self = this
      var data = {
        start_time: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      }
      var url = '/statistic/shopperActivity?start_date=' + data.start_time + '&end_date=' + data.end_time
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var aList = response.data.shopper_activity_list
          for (var i in aList) {
            self.activeLabels.push(moment(aList[i].date, 'YYYY-MM-DD').format('MM/DD'))
            self.shopperActive.cr.push(aList[i].create_order)
            self.shopperActive.cancel.push(aList[i].cancel_order)
            self.shopperActive.search.push(aList[i].search_store)
            self.shopperActive.read.push(aList[i].read_notification)
            self.shopperActive.feedback.push(aList[i].create_feedback)
          }
          self.showShopperActiveChart()
        }
      })
    },
    showShopperChart () {
      this.$nextTick(() => {
        if (typeof todayChart !== 'undefined') {
          todayChart.destroy()
        }
        if (typeof totalChart !== 'undefined') {
          totalChart.destroy()
        }
        // today shopper
        var ctx = document.getElementById('today-shopper').getContext('2d')
        var config = {
          type: 'line',
          data: {
            labels: this.labels,
            datasets: [{
              label: '當日註冊人數',
              fill: false,
              borderColor: '#555555',
              pointBackgroundColor: '#555555',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperState.today.total
            }, {
              label: '當日的通過手機驗證人數',
              borderColor: '#f39c12',
              pointBackgroundColor: '#f39c12',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperState.today.certify
            }, {
              label: '當日Facebook註冊人數',
              borderColor: '#00c0ef',
              pointBackgroundColor: '#00c0ef',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperState.today.fb
            }, {
              label: '當日Google註冊人數',
              borderColor: '#dd4b39',
              pointBackgroundColor: '#dd4b39',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperState.today.google
            }, {
              label: '當日手機註冊人數',
              borderColor: '#3c8dbc',
              pointBackgroundColor: '#3c8dbc',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperState.today.nidin
            }, {
              label: '當日LINE註冊人數',
              borderColor: '#00a65a',
              pointBackgroundColor: '#00a65a',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperState.today.line
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            /*
            elements: {
              line: {
                tension: 0
              }
            },
            */
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        }
        todayChart = new Chart(ctx, config) // eslint-disable-line no-new

        // total shopper
        var ctx2 = document.getElementById('total-shopper').getContext('2d')
        var config2 = {
          type: 'line',
          data: {
            labels: this.labels,
            datasets: [{
              label: '累積註冊人數',
              fill: false,
              borderColor: '#555555',
              pointBackgroundColor: '#555555',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperState.total.total
            }, {
              label: '累積的通過手機驗證人數',
              borderColor: '#f39c12',
              pointBackgroundColor: '#f39c12',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperState.total.certify
            }, {
              label: '累積Facebook註冊人數',
              borderColor: '#00c0ef',
              pointBackgroundColor: '#00c0ef',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperState.total.fb
            }, {
              label: '累積Google註冊人數',
              borderColor: '#dd4b39',
              pointBackgroundColor: '#dd4b39',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperState.total.google
            }, {
              label: '累積手機註冊人數',
              borderColor: '#3c8dbc',
              pointBackgroundColor: '#3c8dbc',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperState.total.nidin
            }, {
              label: '累積LINE註冊人數',
              borderColor: '#00a65a',
              pointBackgroundColor: '#00a65a',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperState.total.line
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            /*
            elements: {
              line: {
                tension: 0
              }
            },
            */
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        }
        totalChart = new Chart(ctx2, config2) // eslint-disable-line no-new
      })
    },
    showShopperActiveChart () {
      if (typeof shopperActiveChart !== 'undefined') {
        shopperActiveChart.destroy()
      }
      this.$nextTick(() => {
          // total shopper
        var ctx = document.getElementById('shopper-active').getContext('2d')
        var config = {
          type: 'line',
          data: {
            labels: this.activeLabels,
            datasets: [{
              label: '當日送出訂單人數',
              fill: false,
              borderColor: '#00a65a',
              pointBackgroundColor: '#00a65a',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperActive.cr
            }, {
              label: '當日取消訂單人數',
              borderColor: '#f39c12',
              pointBackgroundColor: '#f39c12',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperActive.cancel
            }, {
              label: '當日以位置查詢店家人數',
              borderColor: '#00c0ef',
              pointBackgroundColor: '#00c0ef',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperActive.search
            }, {
              label: '有閱讀網頁通知人數',
              borderColor: '#dd4b39',
              pointBackgroundColor: '#dd4b39',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperActive.read
            }, {
              label: '有送出意見人數',
              borderColor: '#337ab7',
              pointBackgroundColor: '#337ab7',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperActive.feedback
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            /*
            elements: {
              line: {
                tension: 0
              }
            },
            */
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        }
        shopperActiveChart = new Chart(ctx, config) // eslint-disable-line no-new
      })
    },
    getHourBrief () {
      this.hourBriefLabels = []
      this.hourBrief = {
        total_order: [],
        total_money: [],
        total_amount: []
      }
      var self = this
      var data = {
        result_type: 1
      }
      var url = '/statistic/storeHourBrief?result_type=' + data.result_type
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.brief
          for (let i in bList) {
            if (typeof parseInt(i, 10) === 'number' && parseInt(i, 10)) {
              if (bList[i].hour < 10) self.hourBriefLabels.push('0' + bList[i].hour + ':00')
              else self.hourBriefLabels.push(bList[i].hour + ':00')
              self.hourBrief.total_order.push(bList[i].total_order)
              self.hourBrief.total_money.push(bList[i].total_money)
              self.hourBrief.total_amount.push(bList[i].total_amount)
            }
          }
          self.showHourBriefChart()
        }
      })
    },
    showHourBriefChart () {
      this.$nextTick(() => {
        var datas = [{
          label: '每小時訂單數量',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.hourBrief.total_order,
          yAxisID: 'y-axis-2'
        }, {
          label: '每小時訂單金額',
          borderColor: '#f39c12',
          pointBackgroundColor: '#f39c12',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.hourBrief.total_money,
          yAxisID: 'y-axis-1'
        }]
        if (typeof hourBriefChart !== 'undefined') {
          hourBriefChart.destroy()
        }
        var ctx = document.getElementById('hour-brief').getContext('2d')
        var config = {
          type: 'line',
          data: {
            labels: this.hourBriefLabels,
            datasets: datas
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        }
        hourBriefChart = new Chart(ctx, config) // eslint-disable-line no-new
      })
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    }
  },
  created () {
    var date = new Date()
    this.menuTime.start.time = moment(date).add(-30, 'days').format('YYYY-MM-DD')
    this.fixedH()
    this.getBrandBrief()
    this.getShopperStatus()
    this.getHourBrief()
  },
  watch: {
    'content.bindingBrandList' () {
      this.changeStoreBrief()
    },
    'content.bindingStoreList' () {
      this.checkLimit()
    },
    'menuTime.storeTime.time' () {
      this.checkLimit()
    }
  }
}
</script>
<style lang="sass">
  .time-box.no-btn
    width: 100% !important
    max-width: inherit
  .time-box.no-btn .cov-vue-date, .time-box.no-btn .cov-vue-date .datepickerbox, .time-box.no-btn .cov-vue-date .datepickbox input
    width: 100% !important
  .info-box
    cursor: pointer
  .info-box-content
    text-align: center
    vertical-align: middle
    display: inherit
  .fullCanvas
    width: 100%
  @media (min-width: 992px)
    .col-md-20-p
      width: 20%
      float: left
</style>



// WEBPACK FOOTER //
// SystemDashboard.vue?577ebc85